"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEllipsisOutlined = exports.StopPropagationWrapper = exports.DropdownAbsoluteWrapper = exports.IconWrapper = void 0;
const polished_1 = require("polished");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
exports.IconWrapper = styled_components_1.default.div `
	display: inline-flex;
	align-items: center;
`;
exports.DropdownAbsoluteWrapper = styled_components_1.default.div `
	z-index: 4;
	cursor: pointer;
	position: absolute;
	top: 1rem;
	left: 1rem;
	border-radius: 0.25rem;
	display: flex;
	align-items: center;
	transition: 0.15s;
	justify-content: center;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.4, theme.color.gray9)};
	:hover {
		background: ${({ theme }) => (0, polished_1.darken)(0.4, theme.color.white)};
	}
`;
exports.StopPropagationWrapper = styled_components_1.default.div `
	width: 2rem;
	height: 2rem;
	padding: 0.25rem;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 100%;
		height: 100%;
		color: ${({ theme }) => theme.color.white};
	}
`;
exports.StyledEllipsisOutlined = (0, styled_components_1.default)(icons_1.EllipsisOutlined) `
	width: 100%;
	height: 100%;
`;
